import { asyncPipeSpread } from 'lib/util'
import { setData } from 'lib/sequence/model/api/set'

/**
 * Sets the `measurement` model's serial from the `sensor` model and converts its `measuredData` to
 * a JSON string.
 *
 * @param module current module
 * @returns {function(...[*]): Promise<*[]>}
 */
const setModelData = (module) => async (...args) => {
  const { sensor, measurement } = module[G.MODEL][G.CHILDREN]
  const { temperatureUnit, measuredData } = measurement[G.CHILDREN]

  setData(measurement, {
    serial: sensor[G.CACHE]?.value?.serial,
    measuredData: JSON.stringify(measuredData[G.CACHE]),
    temperatureUnit: temperatureUnit[G.CACHE] || 'celsius',
  })

  return args
}

/**
 * Measurement Submit Action
 *
 * Prepares the `measurement` model for transmission to the server.
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => () => async (...args) => asyncPipeSpread(
  setModelData(module),
)(args)
